import { without } from 'ramda'
import { Roles } from 'utils/consts/userRoles'
import { databaseFiltersName } from 'utils/consts'
import type { FiltersCollection } from '../filtersCollectionsRegistry'
import type { DatabaseFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import { pickEntries } from './entries'

type Role = string

const brandsFullOrder = [
  databaseFiltersName.usersFilter,
  databaseFiltersName.countryFilter,
  databaseFiltersName.producerFilter,
  databaseFiltersName.registrationFilter,
  databaseFiltersName.sourceFilter,
  databaseFiltersName.creationDateFilter,
  databaseFiltersName.lastUpdateFilter,
  databaseFiltersName.checkedByFilter,
  databaseFiltersName.invalidRecordFilter,
  databaseFiltersName.synonymsFilter,
]

export const getDatabaseBrandsFiltersCollection = (
  role: Role
): FiltersCollection => {
  switch (role) {
    case Roles.PERSON:
    case Roles.MANAGER:
      return pickEntries(
        without(
          [
            databaseFiltersName.sourceFilter,
            databaseFiltersName.checkedByFilter,
            databaseFiltersName.synonymsFilter,
          ],
          brandsFullOrder
        )
      )
    case Roles.CONTENT:
    case Roles.SUPERADMIN:
      return pickEntries(brandsFullOrder)
    default:
      return pickEntries([
        databaseFiltersName.countryFilter,
        databaseFiltersName.producerFilter,
        databaseFiltersName.registrationFilter,
        databaseFiltersName.usersFilter,
        databaseFiltersName.sourceFilter,
        databaseFiltersName.creationDateFilter,
        databaseFiltersName.checkedByFilter,
        databaseFiltersName.invalidRecordFilter,
      ])
  }
}

export const databaseBrandsFiltersConfig: DatabaseFiltersConfig = {
  component: 'database',
  getFiltersCollection: getDatabaseBrandsFiltersCollection,
  showResultsTextKey: 'filters.button.apply',
}
